/**
 * Custom brownie icon (no equivalent in lucide-react).
 * A square brownie viewed from above with chocolate chips on top.
 */
export default function BrownieIcon({ size = 36, className = "" }) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 64 64"
            fill="currentColor"
            stroke="currentColor"
            strokeLinejoin="round"
            strokeLinecap="round"
            className={className}
            aria-hidden="true"
        >
            {/* outer brownie body — slightly rotated, filled */}
            <path
                d="M9 18c0-2 1.5-3.5 3.5-4l36-7c2-0.4 4 1 4.4 3l3 38c.4 2-1 4-3 4.4l-36 4.5c-2 .3-3.8-1.2-4-3.2L9 18z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="3"
            />
            {/* chocolate chips (lighter for contrast) */}
            <g fill="#FFF1E0" stroke="none">
                <circle cx="22" cy="30" r="3" />
                <circle cx="34" cy="26" r="2.6" />
                <circle cx="44" cy="33" r="3.2" />
                <circle cx="26" cy="42" r="2.6" />
                <circle cx="40" cy="48" r="3" />
                <circle cx="50" cy="42" r="2.2" />
            </g>
        </svg>
    );
}
